import { extractPkgInclusions, getInclusionFilterType } from 'lib/offer/inclusionUtils'
import { showFreeCancellation } from 'lib/offer/cancellationPolicyUtils'

export type FilterKey = 'popular' | 'cancellation' | 'upgrade' | 'breakfast'

export function toggleFilter(current: Array<FilterKey>, key: FilterKey): Array<FilterKey> {
  return current.includes(key) ? current.filter(active => active !== key) : [...current, key]
}

export function matchesFilter(view: App.OfferPackageOptionView, filters: Array<FilterKey>, suggestedPackageKey?: string, checkIn?: string, checkOut?: string, luxPlusTier?: App.MembershipTier): boolean {
  if (filters.includes('popular') && view.package.uniqueKey !== suggestedPackageKey) return false
  if (filters.includes('cancellation') && !showFreeCancellation(checkIn, false, view.package.roomRate?.cancellationPolicy)) return false
  if (filters.includes('upgrade') && !view.loyaltyUpgradeAvailability) return false
  const [inclusions, bonusInclusions, luxPlusInclusions] = extractPkgInclusions(view.package, { checkIn, checkOut, luxPlusTier })
  if (filters.includes('breakfast') && ![...inclusions, ...bonusInclusions, ...luxPlusInclusions].some(inclusion => getInclusionFilterType(inclusion) === 'Breakfast')) return false
  return true
}
